import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-freeway-layout-footer-social',
    templateUrl: './freeway-layout-footer-social.component.html',
    standalone: false
})
export class FreewayLayoutFooterSocialComponent {
  @Input() type;
}
